<template>
  <div class="company-service">
    <DomainHeader></DomainHeader>
    <div class="main-container clearfix">

      <div class="tc">
        <h1 class="f24 g3 mt40">套餐购买，省钱更省心</h1>
        <p class="f14 g3 mt20 mb20">
          快捷的在线管理平台，专业的抗攻击服务，贴心的人工代办服务
        </p>
      </div>
      <div class="container clearfix">
        <div class="panel left">
          <div class="header clearfix">
            <h2 class="title">基础服务</h2>
            <p class="description">
              中企域名必备，自主管理+高防DNS服务
            </p>
            <span href="#"
                  class="button">
              注册即免费享有
            </span>
            <!-- <router-link to="/domain-register" class="button">注册即免费享有</router-link> -->
          </div>
          <div class="body">
            <div class="item mt15 ml20 mr20">
              <div class="icon"><img src="../static/assets/platform.png"></div>
              <div class="title">在线管理平台</div>
              <div class="description">自助操作：续费、实名制、解析设置、DNS管理、域名过户等，更多功能持续提供</div>
            </div>
            <div class="item ml20 mr20">
              <div class="icon ips">10万<br>QPS</div>
              <div class="title">基础版DNS</div>
              <div class="description">10万QPS防护上限，市场价值约300元/年，中企客户免费享受</div>
            </div>
            <div class="item fl ttb ttb1">
              <div class="ct ma">1次</div>
              <div class="title mt5 ma">实名制认证</div>
              <div class="yellow-box mt5 ma">人工代办服务</div>
            </div>
            <div class="item fl ttb ttb2">
              <div class="ips whois2 ma">1次
                <br><i>(15元/次)</i>
              </div>
              <div class="title mt5 ma">域名解析调整</div>
              <div class="yellow-box mt5 ma">人工代办服务</div>
            </div>
            <div class="item fl ttb ttb3">
              <div class="ct ma">1次</div>
              <div class="title mt5">WHOIS信息保护</div>
            </div>
          </div>
          <div class="footer">
            <a href="/domain"
               class="button">立即注册域名</a>
          </div>
        </div>

        <div class="panel right active">
          <div class="header clearfix">
            <h2 class="title">企业服务套餐
              <span class="price decoration">¥170.00</span>
            </h2>
            <p class="description">
              更高量级的抗攻击DNS，企业必备的人工代办服务 </p>
            <span class="button">
              优惠、安全、省心
            </span>
            <img src="../static/assets/welcome.png">
          </div>
          <div class="body clearfix">
            <div class="row">
              <div class="item mb10">
                <div class="icon"><img src="../static/assets/platform.png"></div>
                <div class="title">在线管理平台</div>
                <div class="description">自助操作：续费、实名制、解析设置、DNS管理、域名过户等，更多功能持续提供。</div>
                <div class="button">免费</div>
              </div>
              <div class="item mb10">
                <div class="icon middle">1次</div>
                <div class="title">实名制认证
                  <div class="yellow-box dib">人工代办服务</div>
                </div>
                <div class="description">协助企业客户整理和提交域名实名制认证资料，最大程度的保障一次性通过审核。</div>
                <div class="button">域名新注册<br>3个月内免费</div>
                <a :href="'/domain/app-detail/'+MatchProId['MANMADE_REALNAME']"
                   class="view-more">查看详情</a>
              </div>
              <div class="item mb10">
                <div class="icon middle">1次</div>
                <div class="title">WHOIS信息保护
                </div>
                <div class="description">保护域名的注册信息不被公开，让企业远离垃圾邮件和电话骚扰。 </div>
                <!-- <div class="button">域名新注册<br>3个月内免费</div> -->
                <a :href="'/domain/app-detail/'+MatchProId['WHOIS']"
                   class="view-more">查看详情</a>
              </div>
            </div>
            <div class="row">
              <div class="item mb10">
                <div class="icon ips">20万QPS</div>
                <div class="title">高级版DNS
                </div>
                <div class="description">20万QPS防护上限，市场价值约600元/年，中企客户将以极低价格享受。</div>
                <div class="button">120元/年</div>
                <a :href="'/domain/app-detail/'+MatchProId['ENTERPRICE_DNS']"
                   class="view-more">查看详情</a>
              </div>
              <div class="item mb10">
                <div class="icon whois2">3次
                  <i>(15元/次)</i>
                </div>
                <div class="title">域名解析调整
                  <div class="yellow-box dib">人工代办服务</div>
                </div>
                <div class="description">7*24小时服务人员协助您完成域名解析的增、删、改的调整，每次调整10条以内。</div>
                <div class="button">45元</div>
                <a :href="'/domain/app-detail/'+MatchProId['MANMADE_DOMAIN_RESOLUTION']"
                   class="view-more">查看详情</a>
              </div>
              <div class="item mb10">
                <div class="icon middle">1次</div>
                <div class="title">域名安全锁
                </div>
                <div class="description">为企业的重要域名增加“安全锁”，能有效避免恶意篡改信息和转移。</div>
                <div class="button">5元/次</div>
                <!-- <a href="/appDetail/MatchProId['DOMAIN_SECRURITY_LOCK']" class="view-more">查看详情 ></a> -->

                <a :href="'/domain/app-detail/'+MatchProId['DOMAIN_SECRURITY_LOCK']"
                   class="view-more">查看详情</a>
              </div>
            </div>
          </div>

          <div class="footer"
               style="padding: 24px 0;">

            <a href="https://tb.53kf.com/code/client/10168926/3" target="_blank" class="kf53zx bt">在线咨询</a>
          </div>

        </div>

      </div>
      <recommend class="mt30"></recommend>
    </div>
    <el-dialog title="绑定域名"
               :visible.sync="visibleBindDomain"
               width="550px"
               :lock-scroll="false">
      <div v-loading="loadingDomainData">
        <div v-if="domainList.length > 0">
          <div class="f12 domain-dialog-content">
            <el-radio-group v-model="checkedDomain">
              <el-radio v-for="(item,index) in domainList"
                        :key="index"
                        :label="item.id">{{item.domain}}</el-radio>
            </el-radio-group>
          </div>
          <div style="margin-top: 5px;">已开通【高级版DNS】的域名，不支持购买套餐包。</div>
        </div>
        <div v-else>
          <p class="ymbd-tip">当前会员账户下没有可管理的域名，如需购买服务，您需要先进行域名注册或转入已有域名</p>
          <a href="/domain"
             class="ymbd-a1">注册域名</a>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="visibleBindDomain = false">取 消</el-button>
        <el-button type="primary"
                   @click="checkDomain">购 买</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import banner from './components/header'
import recommend from './components/recommend'
import * as $_MatchProId from '../static/scripts/product-id.const'
import DomainHeader from './components/header'
export default {
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: '234324343434234' }
    ]
  },
  data () {
    return {
      MatchProId: $_MatchProId,
      visibleBindDomain: false,
      loadingDomainData: false,
      pId: '',
      pCode: '',
      checkedDomain: '',
      checkedInstCode: '',
      initData: {},
      domainList: [],
      postData: {
        businessType: '1', //1:新购；2:续费
        source: 'AFFICIAL_WEBSITE', //来源,商店:APP_STORE;官网:AFFICIAL_WEBSITE
        skuId: '', //skuId,页面上可以取到
        mainInstanceCode: '', //主商品实例code
        extInstanceCode: '', //扩展实例code
        goodsNum: 1, //购买数量
        timeLong: '1', //购买年限
        isSyncMainTime: false //是否与主体保持一致
      }
    }
  },
  components: {
    banner,
    recommend,
    DomainHeader
  },
  created () { },
  methods: {
    openDomainDialog () {
      this.loadingDomainData = true
      this.visibleBindDomain = true
      this.$_getInstList()
    },

    checkDomain () {
      this.domainList.forEach(element => {
        if (element.id == this.checkedDomain) {
          this.checkedDomain_show = element.domain
          this.checkedInstCode = element.instanceCode
          this.postData.mainInstanceCode = this.checkedInstCode
        }
      })
      this.visibleBindDomain = false
      if (this.checkedDomain != '') {
        this.$router.push({
          path: '/domain/confirm/' + JSON.stringify([this.postData])
        })
      }
    },
    $_getInstList () {
      this.domainList = []
      $.get('/security/domainGoods/detailByCode', {
        code: 'domain0005',
        type: '1'
      }).then(res => {
        if (res.status) {
          this.$message.error(res.msg)
          this.loadingDomainData = false
          return
        } else {
          this.initData = res.data
          this.pId = this.initData.id
          this.postData.skuId = res.data.skuVoList[0].id

          $.get('/security/domainGoods/instList', { goodsId: this.pId }).then(
            res => {
              this.domainList = res.data
              this.loadingDomainData = false
            },
            err => {
              this.loadingDomainData = false
            }
          )
        }
      })
    }
  }
}
</script>
<style  lang="scss">
@import "../static/css/home.scss";
</style>



// WEBPACK FOOTER //
// src/home.vue